import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/apps/web/components/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/styles/globals.css");
